var map = {
	"./24hrsPremiumTag.svg": 31364,
	"./AAcoin.webp": 89117,
	"./addNewPools.svg": 42512,
	"./allchain.svg": 2086,
	"./allchainActive.svg": 77724,
	"./arrow-up.svg": 14777,
	"./avax.svg": 11300,
	"./avaxIcon.svg": 5535,
	"./avaxStake.svg": 9282,
	"./avaxStakeActive.svg": 28208,
	"./baseActive copy.svg": 17494,
	"./baseActive.svg": 38651,
	"./baseInactive.svg": 44482,
	"./benqi.svg": 87239,
	"./bnbChain.svg": 41115,
	"./bnbIcon.svg": 163,
	"./bnbStake.svg": 13390,
	"./bnbStakeActive.svg": 64788,
	"./bpicon copy.webp": 93146,
	"./bpicon.webp": 38609,
	"./bsc.svg": 70970,
	"./btcb.svg": 96151,
	"./busd.svg": 83184,
	"./buybackTag.svg": 74053,
	"./calculator.svg": 63782,
	"./calculatorButtonBg.png": 26509,
	"./carrot copy.webp": 1098,
	"./carrot.webp": 93441,
	"./cawsLabel.svg": 81530,
	"./cawsbanner.svg": 79898,
	"./cawslogo.png": 1007,
	"./cawslogo.svg": 54533,
	"./coin.webp": 65559,
	"./coinBackground.webp": 43259,
	"./comingSoon.svg": 43222,
	"./comingSoonTag.svg": 43102,
	"./dai.svg": 92320,
	"./decrease.png": 57304,
	"./disabledFarming.svg": 67054,
	"./disabledStaking.svg": 69089,
	"./disabledVault.svg": 12354,
	"./dyplogo.svg": 40564,
	"./earnHeroBackground.webp": 56820,
	"./earnHeroMobileBg.png": 18273,
	"./earnHeroStats.webp": 42443,
	"./ellipse.svg": 57224,
	"./esc copy.svg": 29904,
	"./esc.svg": 21841,
	"./ethStake.svg": 69415,
	"./ethStakeActive.svg": 27445,
	"./ethereum.svg": 27709,
	"./ethereumIcon.svg": 65402,
	"./fsn.svg": 29875,
	"./gold.png": 70514,
	"./greenarrow.svg": 80386,
	"./idypius.svg": 27099,
	"./increase.png": 42412,
	"./lanft-poolicon.png": 30429,
	"./link.svg": 92118,
	"./listIcon.svg": 61241,
	"./listIconActive.svg": 28015,
	"./metamaskVideo.png": 17722,
	"./more-info.svg": 4070,
	"./mrsbunny.png": 97216,
	"./newCawsLogo.png": 15363,
	"./newPool.png": 99934,
	"./noPoolsIcon.svg": 73367,
	"./orangearrow.svg": 34535,
	"./pancakeswap.svg": 92354,
	"./pangolin.svg": 77742,
	"./playButton.svg": 39976,
	"./premiumIcon.svg": 414,
	"./premiumTag.svg": 89979,
	"./purpleArrow.svg": 75499,
	"./silver.png": 8835,
	"./stakeTag.svg": 95344,
	"./stakeVideo.png": 71523,
	"./staked.svg": 24988,
	"./tableIcon.svg": 45409,
	"./tableIconActive.svg": 97095,
	"./token.webp": 48635,
	"./toppick.svg": 2456,
	"./toppools-bg.png": 71172,
	"./totalTvlBg.svg": 32223,
	"./totalTvlIcon.svg": 65245,
	"./tvlBackground.png": 97160,
	"./tvlBackground.webp": 58504,
	"./usdc.svg": 37777,
	"./usdt.svg": 82366,
	"./wbtc.svg": 14794,
	"./weth.svg": 62590,
	"./xava.svg": 11216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43846;